module.exports = __webpack_public_path__ + "static/media/holiday_help.b3d2c02f.svg";